import { render, staticRenderFns } from "./ReservationCountByPriceCategory.vue?vue&type=template&id=e4531742"
import script from "./ReservationCountByPriceCategory.vue?vue&type=script&lang=js"
export * from "./ReservationCountByPriceCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports